import { memo, useEffect } from 'react'

export const GoogleNativeAdMobile = memo(function _GoogleNativeAdMobile() {
  useEffect(() => {
    try {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    } catch (e) {
      console.error(e)
    }
  }, [])

  return (
    <>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5590101971803078"
        crossOrigin="anonymous"
      ></script>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="fluid"
        data-ad-layout-key="-gp+s-1b-ew+vy"
        data-ad-client="ca-pub-5590101971803078"
        data-ad-slot="2464049957"
      ></ins>
    </>
  )
})

export const GoogleNativeAdDesktop = memo(function _GoogleNativeAdDesktop() {
  useEffect(() => {
    try {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    } catch (e) {
      console.error(e)
    }
  }, [])

  return (
    <>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5590101971803078"
        crossOrigin="anonymous"
      ></script>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="fluid"
        data-ad-layout-key="-gb-3b+bl-7c-bo"
        data-ad-client="ca-pub-5590101971803078"
        data-ad-slot="2750495579"
      ></ins>
    </>
  )
})
